<script>
    let { kind, entryId, onUpdate = () => {} } = $props();
</script>

<div class="lead-actions">
    <button onclick={() => onUpdate(kind, entryId, "contacted")}>Out</button>
    <button onclick={() => onUpdate(kind, entryId, "in_review")}>In</button>
    <button onclick={() => onUpdate(kind, entryId, "closed")}>Close</button>
</div>
